<template>
  <div class="header-main">
    <div class="container">
      <div class="logo-wrap">
        <router-link to="/"
          ><img src="~@/assets/images/logo.png"
        /></router-link>
      </div>
      <div class="nav-wrap">
        <a @click="toggleMenu" class="menulinks" :class="isMenuShow?'open':''"><i></i></a>
        <ul class="mainmenu" :class="isMenuShow?'show':''">
          <li><router-link to="/trip/search">Search</router-link></li>
          <li><router-link to="/faq">FAQ</router-link></li>
          <li><router-link to="/about-us">About Us</router-link></li>
          <li><router-link to="/media">Media</router-link></li>
          <li><a href="https://blog.sharedcharter.com/">Blog</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  
  data() {
    return{
      isMenuShow: false
    }
  },
  methods:{
    toggleMenu:function(){
      this.isMenuShow = !this.isMenuShow;
    }
  }
}
</script>

<style scoped>
/*Nav*/
.nav-menu {
  float: right;
}

.menulinks {
  display: none;
  text-align: center;
  width: 41px;
  height: 35px;
  line-height: 35px;
  color: #fff;
  font-size: 22px;
  position: absolute;
  top: 20px;
  right: 15px;
  cursor: pointer;
}
ul.mainmenu {
  vertical-align: middle;
  display: inline-block;
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
  display: block;
  opacity: 0;
  visibility: hidden;
  margin-top: 10px;
  transition: all 0.5s ease;
}
ul.mainmenu.show{
   opacity: 1;
   visibility: visible;
   margin-top: 0;
}
ul.mainmenu > li {
  display: inline-block;
  padding: 0 10px;
  position: relative;
}
ul.mainmenu > li > a:link,
ul.mainmenu > li > a:visited {
  padding: 5px 5px;
  display: inline-block;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #2597d8;
  font-family: "Work Sans", sans-serif;
  line-height: 18px;
  letter-spacing: -0.6px;
  border-bottom: 2px solid rgba(255, 255, 255, 0);
  position: relative;
}
ul.mainmenu > li > a:hover,
ul.mainmenu > li > a.current {
  color: #000234;
}
ul.mainmenu > li > a.current {
  border-bottom-color: #16c1f3;
}
ul.mainmenu > li > a.current:after {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-top-color: #16c1f3;
  border-width: 8px;
  margin-left: -8px;
}

ul.mainmenu ul {
  position: absolute;
  left: 0;
  width: 250px;
  padding: 0;
  list-style: none;
  margin: 0;
  background: #111;
  z-index: 2;
  display: none;
}
ul.mainmenu ul li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
ul.mainmenu ul li:last-child {
  border-bottom: none;
}
ul.mainmenu li li a:link,
ul.mainmenu li li a:visited {
  color: #fff;
  display: block;
  padding: 8px 15px;
  font-size: 15px;
}
ul.mainmenu li li a:hover {
  background: #333;
}
/*Nav*/

@media (min-width: 768px) {
  ul.mainmenu {
    display: block !important;
    opacity: 1;
    visibility: visible;
  }
  ul.mainmenu li:hover ul {
    display: block;
  }
}
@media (max-width: 991px) {
  .header-main .logo-wrap {
    max-width: 220px;
  }
}
@media (max-width: 767px) {
  .menulinks {
    display: inline-block;
  }
  ul.mainmenu {
    text-align: left;
    position: absolute;
    top: 81px;
    padding: 0;
    right: 0;
    width: 100%;
    background: #000234;
    z-index: 9999999;
  }
  ul.mainmenu > li {
    float: left;
    width: 100%;
    padding: 0px;
    margin: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
  }
  ul.mainmenu > li:first-child {
    border: none;
  }
  ul.mainmenu > li > a:link,
  ul.mainmenu > li > a:visited {
    padding: 10px 15px;
    font-size: 16px;
    float: left;
    width: 100%;
    border: none;
    text-align: left;
    color: #fff;
  }
  ul.mainmenu > li > a:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  a.menulinks i {
    display: inline;
    position: relative;
    top: -2px;
    margin-left: 0;
    -webkit-transition-duration: 0s;
    -webkit-transition-delay: 0.2s;
    -moz-transition-duration: 0s;
    -moz-transition-delay: 0.2s;
    transition-duration: 0s;
    transition-delay: 0.2s;
  }
  a.menulinks i:before,
  a.menulinks i:after {
    position: absolute;
    content: "";
    left: 0;
  }
  a.menulinks i,
  a.menulinks i:before,
  a.menulinks i:after {
    width: 30px;
    height: 5px;
    background-color: #2597d8;
    display: inline-block;
  }
  a.menulinks i:before {
    margin-top: -10px;
    -webkit-transition-property: margin, -webkit-transform;
    -webkit-transition-duration: 0.2s;
    -webkit-transition-delay: 0.2s, 0;
  }
  a.menulinks i:after {
    margin-top: 10px;
    -webkit-transition-property: margin, -webkit-transform;
    -webkit-transition-duration: 0.2s;
    -webkit-transition-delay: 0.2s, 0;
  }
  a.menulinks.open i {
    background-color: rgba(0, 0, 0, 0);
    -webkit-transition-delay: 0.2s;
    -webkit-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
    -moz-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
  }
  a.menulinks.open i:before {
    margin-top: 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transition-delay: 0, 0.2s;
    -webkit-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
    -moz-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
  }
  a.menulinks.open i:after {
    margin-top: 0;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transition-delay: 0, 0.2s;
    -webkit-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
    -moz-box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0);
  }

  ul.mainmenu > li > a.current:after {
    display: none;
  }
  ul.mainmenu ul {
    position: relative;
    top: auto;
    left: auto;
    float: left;
    width: 100%;
  }
  ul.mainmenu ul li {
    position: relative;
  }
  ul.mainmenu ul li a {
    padding: 8px 15px 8px 25px;
    color: #fff;
  }
  a.child-triggerm {
    display: block !important;
    cursor: pointer;
    position: absolute !important;
    top: 0px;
    right: 0px;
    width: 50px !important;
    min-width: 50px !important;
    height: 38px !important;
    padding: 0 !important;
    border-left: 1px dotted rgba(255, 255, 255, 0.2);
  }
  a.child-triggerm:hover {
    text-decoration: none;
    color: #f00;
  }
  a.child-triggerm span {
    position: relative;
    top: 50%;
    margin: 0 auto !important;
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    transition-duration: 0.2s;
  }
  a.child-triggerm span:after {
    position: absolute;
    content: "";
  }
  a.child-triggerm span,
  a.child-triggerm span:after {
    width: 10px;
    height: 1px;
    background-color: #fff;
    display: block;
  }
  a.child-triggerm span:after {
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    transition-duration: 0.2s;
  }
  a.child-triggerm.child-open span:after {
    -webkit-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    transform: rotate(-180deg);
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    transition-duration: 0.2s;
  }
  a.child-triggerm.child-open span {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    transition-duration: 0.2s;
  }

  a.child-triggerm:hover span,
  a.child-triggerm:hover span:after {
    background-color: #f00;
  }
}
</style>
